import React from "react";
import { Card, CardContent, Typography } from "@mui/material";

export default function TelemetryEmpty() {
  return (
    <Card
      elevation={0}
      sx={{
        borderRadius: 4,
        border: "1px solid #e2e8f0",
      }}
    >
      <CardContent sx={{ p: 5, textAlign: "center" }}>
        <Typography sx={{ fontSize: 22, fontWeight: 800, color: "#0f172a" }}>
          No telemetry data found
        </Typography>
        <Typography sx={{ mt: 1, color: "#64748b" }}>
          Start your Django MQTT listener and dummy publisher.
        </Typography>
      </CardContent>
    </Card>
  );
}